import type { IconGlyph } from '../icon';

/**
 * Tractie `eye-thick` glyph (medium, 24×24), shown on a selected item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/eye-thick.jsx`.
 * Verbatim copy of the SVG `d` attributes.
 */
export const iconEyeThick: IconGlyph = {
  name: 'eye-thick',
  path: [
    'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2',
    'M12 5C6.48 5 2 11 2 12s4.48 7 10 7 10-6 10-7-4.48-7-10-7m7.59 7.35c-.42.59-1.06 1.32-1.86 2.04C16.09 15.86 14.05 17 12 17s-4.09-1.14-5.73-2.61c-.8-.72-1.43-1.45-1.86-2.04-.09-.13-.17-.24-.24-.35.07-.1.14-.22.24-.35.42-.59 1.06-1.32 1.86-2.04C7.91 8.14 9.95 7 12 7s4.09 1.14 5.73 2.61c.8.72 1.43 1.45 1.86 2.04.09.13.17.24.24.35-.07.1-.14.22-.24.35',
  ],
};
